import CloseIcon from '@mui/icons-material/Close';
import { SvgIcon } from '@mui/material';
import _isNil from 'lodash/isNil';
import React, { useEffect, useMemo, useState } from 'react';
import Button from '@Components/Button/Button';
import IconButton from '@Components/IconButton/IconButton';
import { ISettingsOption } from '@Components/Settings/Interfaces';
import Styles from './SettingsDialogInnerComponent.scss';

interface ISettingsDialogInnerComponentProps {
    title: string;
    editEntity: string | null;
    onClose: () => void;
    settingsOptions: Array<ISettingsOption>;
    isSubmitting: boolean;
}

const SettingsDialogInnerComponent = (
    props: ISettingsDialogInnerComponentProps
) => {
    const { title, editEntity, onClose, settingsOptions, isSubmitting } = props;

    const [selectedSettingsOption, setSelectedSettingsOption] =
        useState<ISettingsOption | null>(null);

    useEffect(() => {
        if (_isNil(selectedSettingsOption) && !_isNil(settingsOptions)) {
            setSelectedSettingsOption(settingsOptions[0]);
        }
    }, [settingsOptions, selectedSettingsOption]);

    const getButtonColor = (option) => {
        return option?.title === selectedSettingsOption?.title
            ? 'blue'
            : 'indigo';
    };

    const optionsButtons = settingsOptions.map((option, index) => {
        return (
            <Button
                id={`${option.id}-btn`}
                key={index}
                onClick={() => setSelectedSettingsOption(option)}
                color={getButtonColor(option)}
                className={Styles.optionsButton}
                disabled={isSubmitting}
            >
                {option.title}
            </Button>
        );
    });

    const augmentedBaseComponent = selectedSettingsOption
        ? React.cloneElement(selectedSettingsOption.baseComponent, {
              isSubmitting: isSubmitting,
              title: selectedSettingsOption.title,
              id: selectedSettingsOption.id,
          })
        : null;

    return (
        <div className={Styles.wrapper}>
            <div className={Styles.options}>
                <div className={Styles.optionsHeader}>
                    <IconButton
                        id="close-settings-btn"
                        onClick={onClose}
                        style={{
                            color: 'white',
                            backgroundColor: '#1A1E2C',
                            height: '40px',
                            width: '36px',
                        }}
                        className={Styles.closeButton}
                        icon={
                            <SvgIcon inheritViewBox>
                                <CloseIcon />
                            </SvgIcon>
                        }
                    />
                    <div className={Styles.optionsTitleContainer}>
                        <div
                            id="settings-title"
                            className={Styles.optionsTitle}
                        >
                            {title}
                        </div>
                        {!_isNil(editEntity) && (
                            <div
                                id="edit-entity-name"
                                className={Styles.optionsEditEntity}
                            >
                                {editEntity}
                            </div>
                        )}
                    </div>
                </div>
                <div className={Styles.optionsButtons}>{optionsButtons}</div>
            </div>
            <div className={Styles.mainContainer}>{augmentedBaseComponent}</div>
        </div>
    );
};

export default SettingsDialogInnerComponent;
